import { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AdminPage from "@/pages/AdminPage";
import PaymentResult from "@/pages/PaymentResult";
import TrackOrder from "@/pages/TrackOrder";
import ContactPage from "@/pages/ContactPage";
import ProductPage from "@/pages/ProductPage";
import ChatWidget from "@/components/ChatWidget";
import "@/App.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-10 text-center">
          <div>
            <p className="font-display text-3xl font-semibold text-ink">
              Oops — something sparkled out.
            </p>
            <p className="mt-3 text-muted">
              Refresh the page to keep exploring Sparkwear.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <CartProvider>
        <BrowserRouter>
          <SmoothScroll />
          <div className="min-h-screen bg-cream font-body text-ink">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
              <Route path="/track" element={<TrackOrder />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
            </Routes>
            <Footer />
            <ChatWidget />
          </div>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </ErrorBoundary>
  );
}

export default App;
